/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mustard': {
    width: 960,
    height: 560,
    viewBox: '0 0 960 560',
    data: '<path pid="0" d="M566.2 264.8L547.7 224l19.4-52c1.6-4.4-.6-9.2-5-10.9l-14.6-5.4L560 79.3l.6-4c0-1-7.2-3.8-7.5-2.8l-2.2 3.4-40.8 65.9-14.2-5.4c-4.4-1.6-9.3.6-11 5l-19.4 52-40.5 18.5c-6.9 3.1-12.4 8.9-15 16l-71.8 191.3c-14 37.4 61 65.4 61 65.4l7.5 2.8s75 28 89.4-9.4l71.4-191.2c2.4-7.2 2-15.1-1.3-22zm-70.8 144.8c-4.8 13-117.2-29-112-41.9L425 255.2l112.4 42-42 112.4z"/>'
  }
})
